import React from 'react';
import { useNavigate } from 'react-router-dom'; 
import logo from '../../img/logo.png';
import text_logo from '../../img/text_logo.png';
import './Header.css';

function Header() {
  const navigate = useNavigate();
  const startPage = () =>{
    navigate("/");
    window.location.reload();
}
  
  return (
    <div className="header">
      <div>
        <img src={logo} onClick={startPage} className="logo"/>
      </div>
    
    </div>
  );
}

export default Header;
